import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal } from "../components/Reveal";
import { SampleTag } from "../components/SampleTag";
import { PANEL_FILTERS, PANELISTS } from "../data/sampleData";

const Panel = () => {
    const [filter, setFilter] = useState("All");
    const visible = PANELISTS.filter(
        (p) => filter === "All" || p.exams.includes(filter)
    );

    return (
        <main className="py-20 md:py-28" data-testid="panel-page">
            <div className="wrap">
                <Reveal className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                    <div>
                        <p className="eyebrow">The panel</p>
                        <h2 className="mt-4 max-w-2xl text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                            People who have <em className="italic text-brass">sat on the other side.</em>
                        </h2>
                    </div>
                    <SampleTag />
                </Reveal>

                <Reveal className="mt-12">
                    <div
                        className="flex flex-wrap gap-2"
                        role="group"
                        aria-label="Filter panelists by exam"
                    >
                        {PANEL_FILTERS.map((f) => (
                            <button
                                key={f}
                                type="button"
                                data-testid={`filter-${f.toLowerCase().replace(" ", "-")}`}
                                onClick={() => setFilter(f)}
                                aria-pressed={filter === f}
                                className={`border px-5 py-2.5 text-[13px] tracking-wide transition-colors duration-300 ${
                                    filter === f
                                        ? "border-pine bg-pine text-paper"
                                        : "border-line bg-transparent text-ink-muted hover:border-brass hover:text-brass"
                                }`}
                            >
                                {f}
                            </button>
                        ))}
                    </div>
                </Reveal>

                <AnimatePresence mode="wait">
                    <motion.div
                        key={filter}
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                        className="mt-10 grid gap-px border border-line bg-line md:grid-cols-2"
                        data-testid="panelist-grid"
                    >
                        {visible.map((p) => (
                            <div
                                key={p.id}
                                data-testid={`panelist-${p.id}`}
                                className="bg-paper p-8 sm:p-10"
                            >
                                <div className="flex items-start justify-between gap-4">
                                    <div className="flex h-12 w-12 items-center justify-center bg-pine font-display text-base text-paper">
                                        {p.initials}
                                    </div>
                                    <p className="text-sm tabular-nums text-brass">
                                        {p.years} years
                                    </p>
                                </div>
                                <h3 className="mt-6 text-2xl tracking-tight">
                                    {p.name}
                                </h3>
                                <p className="mt-3 max-w-md text-sm leading-relaxed text-ink-muted">
                                    {p.background}
                                </p>
                                <div className="mt-6 flex flex-wrap gap-2">
                                    {p.exams.map((e) => (
                                        <span
                                            key={e}
                                            className="border border-line px-3 py-1 text-[11px] uppercase tracking-[0.14em] text-ink-muted"
                                        >
                                            {e}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </motion.div>
                </AnimatePresence>
            </div>
        </main>
    );
};

export default Panel;
